import { TypedForm, ObjectSchema, string, object } from 'libs/form';

export interface LegalClientBranchNameFormType {
  branchName: {
    fullName: string;
  };
}

const maxLengthName = 200;

export const branchNameSchema: ObjectSchema<LegalClientBranchNameFormType> =
  object({
    branchName: object({
      fullName: string().max(maxLengthName).required(),
    }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientBranchNameFormType>();
